// extracted by mini-css-extract-plugin
export default {"root":"PlainDivider_root__yIaMF","placeHolderShimmer":"PlainDivider_placeHolderShimmer__nf57y"};